/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface UpdatedAt
 */
export interface UpdatedAt {}

/**
 * Check if a given object implements the UpdatedAt interface.
 */
export function instanceOfUpdatedAt(value: object): boolean {
    return true;
}

export function UpdatedAtFromJSON(json: any): UpdatedAt {
    return UpdatedAtFromJSONTyped(json, false);
}

export function UpdatedAtFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatedAt {
    return json;
}

export function UpdatedAtToJSON(value?: UpdatedAt | null): any {
    return value;
}
